// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FileBubble__bubble-c9e668 {
  min-width: var(--file-bubble-min-width);
}

.FileBubble__container-c49194 {
  position: relative;
}

.FileBubble__sender-name-c0a91f {
  overflow-x: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 4px;
}

.FileBubble__quote-ebf9a9 {
  margin-bottom: 9px;
}

.FileBubble__forward-e8d865 {
  margin-bottom: 4px;
}

.FileBubble__status-bar-abaf0f {
  position: absolute;
  bottom: 0;
  right: 0;
}

.FileBubble__comment-fdf719 {
  padding: 8px 0;
  color: var(--base-110);
}

.FileBubble__comment-text-b293ca {
  display: inline;
}

.FileBubble__commented-status-bar-fe0f58 {
  float: right;
  margin-top: 6px;
  margin-inline-start: var(--indent-8px);
}

.FileBubble__thread-button-f7adee {
  margin: 10px -12px -10px -12px;
}

.FileBubble__text-f8581c {
  color: var(--chat-bubble-text-primary);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/FileBubble/FileBubble.styles.m.scss"],"names":[],"mappings":"AAAA;EACE,uCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;AAAF;;AAGA;EACE,cAAA;EACA,sBAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,YAAA;EACA,eAAA;EACA,sCAAA;AAAF;;AAGA;EACE,8BAAA;AAAF;;AAGA;EACE,sCAAA;AAAF","sourcesContent":[".bubble {\n  min-width: var(--file-bubble-min-width);\n}\n\n.container {\n  position: relative;\n}\n\n.sender-name {\n  overflow-x: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n\n  margin-bottom: 4px;\n}\n\n.quote {\n  margin-bottom: 9px;\n}\n\n.forward {\n  margin-bottom: 4px;\n}\n\n.status-bar {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n.comment {\n  padding: 8px 0;\n  color: var(--base-110);\n}\n\n.comment-text {\n  display: inline;\n}\n\n.commented-status-bar {\n  float: right;\n  margin-top: 6px;\n  margin-inline-start: var(--indent-8px);\n}\n\n.thread-button {\n  margin: 10px -12px -10px -12px;\n}\n\n.text {\n  color: var(--chat-bubble-text-primary);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bubble": `FileBubble__bubble-c9e668`,
	"container": `FileBubble__container-c49194`,
	"sender-name": `FileBubble__sender-name-c0a91f`,
	"senderName": `FileBubble__sender-name-c0a91f`,
	"quote": `FileBubble__quote-ebf9a9`,
	"forward": `FileBubble__forward-e8d865`,
	"status-bar": `FileBubble__status-bar-abaf0f`,
	"statusBar": `FileBubble__status-bar-abaf0f`,
	"comment": `FileBubble__comment-fdf719`,
	"comment-text": `FileBubble__comment-text-b293ca`,
	"commentText": `FileBubble__comment-text-b293ca`,
	"commented-status-bar": `FileBubble__commented-status-bar-fe0f58`,
	"commentedStatusBar": `FileBubble__commented-status-bar-fe0f58`,
	"thread-button": `FileBubble__thread-button-f7adee`,
	"threadButton": `FileBubble__thread-button-f7adee`,
	"text": `FileBubble__text-f8581c`
};
module.exports = ___CSS_LOADER_EXPORT___;
